export default __webpack_public_path__ + "static/media/Discover.f656fc9f.svg";